"use client";

import { useParams } from "next/navigation";
import { BreadcrumbManaged } from "@repo/ui/components/ui/breadcrumb";
import Icon from "@repo/ui/components/ui/icon/icon";
import Scroll from "@repo/next-shared/components/scroll";
import { useTranslations } from "next-intl";
import { useFaq } from "@repo/next-shared/data/faq";
import HelpPageContactLink from "@repo/next-shared/components/help-page/help-page-contact-link";
import { Separator } from "@repo/ui/components/ui/separator";
import HelpItems from "@repo/next-shared/components/help-page/help-items";
import RichText from "@repo/next-shared/components/rich-text";
import Link from "next/link";

function parseRichLink(content: string, link: string) {
  const parts = content.split(/<link>(.*?)<\/link>/);
  return parts.map((part, i) =>
    i % 2 ? (
      <a
        className="underline"
        key={i}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {part}
      </a>
    ) : (
      part
    ),
  );
}

const FaqPage = () => {
  const params = useParams();
  const { data } = useFaq("CONSUMER", params.id as string);
  const t = useTranslations("Help");

  const breadcrumbItems = [
    {
      text: t("Contact-form.back"),
      href: "../",
    },
  ];

  return (
    <div className="m-auto">
      <Scroll />
      <BreadcrumbManaged items={breadcrumbItems}>
        <Icon
          icon="Arrow"
          className="w-4 h-4 stroke-primary-magenta rotate-180"
        />
      </BreadcrumbManaged>
      {data && (
        <>
          <h2 className="mt-7">{data.faq.title}</h2>
          <div className="font-bold my-[40px] p-[20px] max-w-max rounded-full border-2 dark:border-primary-white border-secondary-black leading-none">
            {data.category.title}
          </div>
          <p className="mt-7">
            <RichText
              components={{
                "x-link": (chunks) => (
                  <a
                    className="underline inline-block"
                    href="/legal"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {chunks}
                  </a>
                ),
              }}
            >
              {data.faq?.content}
            </RichText>
          </p>
          <Separator className="my-10 max-md:my-4 dark: bg-secondary-gray3"></Separator>
          <h2 className="mt-7">{t("related-articles")}</h2>
          <HelpItems items={data.category.items} />
          <Separator className="my-10 max-md:my-4 dark: bg-secondary-gray3"></Separator>
          <HelpPageContactLink contactFormLink="/help/contact" />
        </>
      )}
    </div>
  );
};

export default FaqPage;
